import { render, staticRenderFns } from "./CommentWidget.vue?vue&type=template&id=17aba95c&"
import script from "./CommentWidget.vue?vue&type=script&lang=ts&"
export * from "./CommentWidget.vue?vue&type=script&lang=ts&"
import style0 from "./CommentWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports